import { Dropdown, Field, Input, Option } from '@fluentui/react-components';
import { useState } from 'react';
import { PageHeader } from '../../common/PageHeader';
import { DataTable } from '../../common/DataTable';
import { LoadingState } from '../../common/LoadingState';
import { ErrorState } from '../../common/ErrorState';
import { useOrders } from '../../../hooks/useOrders';
import { OrderStatus } from '../../../models/enums';
import { StatusBadge } from '../../common/StatusBadge';
import { OrderDetailPanel } from './OrderDetailPanel';

export const OrdersListPage = () => {
  const { orders, loading, error, search, setSearch, status, setStatus, reload } = useOrders();
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);
  const selectedOrder = orders.find((item) => item.cr_crm_orderid === selectedOrderId) ?? null;

  if (loading) return <LoadingState label="Loading orders..." />;
  if (error) return <ErrorState message={error} onRetry={() => void reload()} />;

  return (
    <div>
      <PageHeader title="Orders" subtitle="Read-only view of synchronized Partner Center orders" />
      <div style={{ display: 'flex', gap: 12, marginBottom: 16, alignItems: 'end' }}>
        <Field label="Search"><Input value={search} onChange={(_, data) => setSearch(data.value)} /></Field>
        <Field label="Status"><Dropdown selectedOptions={[String(status)]} value={status === 'all' ? 'All statuses' : undefined} onOptionSelect={(_, data) => setStatus(data.optionValue === 'all' ? 'all' : Number(data.optionValue) as OrderStatus)}><Option value="all">All statuses</Option><Option value={String(OrderStatus.Pending)}>Pending</Option><Option value={String(OrderStatus.Completed)}>Completed</Option><Option value={String(OrderStatus.Cancelled)}>Cancelled</Option><Option value={String(OrderStatus.Suspended)}>Suspended</Option><Option value={String(OrderStatus.Failed)}>Failed</Option></Dropdown></Field>
      </div>
      <DataTable
        items={orders}
        columns={[
          { columnId: 'number', label: 'Reference', renderCell: (item) => item.cr_crm_orderreference ?? '—' },
          { columnId: 'client', label: 'Client', renderCell: (item) => item.cr_crm_client?.cr_crm_companyname ?? '—' },
          { columnId: 'status', label: 'Status', renderCell: (item) => <StatusBadge value={item.cr_crm_status} /> },
          { columnId: 'usd', label: 'Total USD', renderCell: (item) => item.cr_crm_totalamountusd != null ? `$ ${item.cr_crm_totalamountusd.toFixed(2)}` : '—', compare: (a, b) => (a.cr_crm_totalamountusd ?? 0) - (b.cr_crm_totalamountusd ?? 0) },
        ]}
        getRowId={(item) => item.cr_crm_orderid}
        onRowClick={(item) => setSelectedOrderId(item.cr_crm_orderid)}
      />
      <OrderDetailPanel order={selectedOrder} open={Boolean(selectedOrder)} onOpenChange={(open) => { if (!open) setSelectedOrderId(null); }} />
    </div>
  );
};
